// #260's aggregate counts the same stored entries as both legacy roster arrays.
// Zero is authoritative; identities are never reconstructed from this count.
export const getParticipantCount = game => game?.participant_count
  ?? ((game?.team_a_players?.length ?? 0) + (game?.team_b_players?.length ?? 0));
